import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputModule } from '@rappi/ui/input';

import { LearningHubRoutingModule } from './learning-hub.routing';
import { ArticleDetailComponent } from './components/article-detail/article-detail.component';
import { ArticleListComponent } from './components/article-list/article-list.component';
import { ArticleRowsComponent } from './components/article-rows/article-rows.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CategoryComponent } from './components/category/category.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { LayoutComponent } from './components/layout/layout.component';
import { SearchBoxComponent } from './components/search-box/search-box.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { LearningHubLegacyRedirectGuard } from './guards/learning-hub-legacy-redirect.guard';
import { LearningHubTranslatePipe } from './pipes/learning-hub-translate.pipe';
import { LearningHubI18nService } from './services/learning-hub-i18n.service';
import { LearningHubService } from './services/learning-hub.service';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, InputModule, LearningHubRoutingModule],
  declarations: [
    LayoutComponent,
    HeaderComponent,
    HomeComponent,
    CategoryComponent,
    ArticleListComponent,
    ArticleDetailComponent,
    ArticleRowsComponent,
    BreadcrumbComponent,
    SearchBoxComponent,
    SidebarComponent,
    LearningHubTranslatePipe
  ],
  providers: [LearningHubService, LearningHubI18nService, LearningHubLegacyRedirectGuard]
})
export class LearningHubModule {}
